import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    title: "개발환경에서만 보입니다.",
    class: "is-debug"
};
const _hoisted_2 = {
    key: 0,
    title: "개발환경에서만 보입니다.",
    class: "is-debug"
};
const _hoisted_3 = {
    key: 0,
    title: "개발환경에서만 보입니다.",
    class: "is-debug"
};
const _hoisted_4 = ["data-cy"];
import { ref, watch, onMounted, } from 'vue';
import { i18n } from '@/locales';
import { useRoute, useRouter, } from 'vue-router';
import { convertCase } from '@/utils';
import { getGlobalStore } from '@/lib/global-store';
import { routeName } from '@/constants/routeName';
import { initMenu, } from '@/constants/menu';
const lc = 'views.menu.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Menu',
    setup(__props) {
        const vuexStore = getGlobalStore();
        const router = useRouter();
        // 라우트 바뀌었을 때 세부 탭대응 (라이더 상세 진입 시에도 라이더 관리 선택상태 유지)
        const route = useRoute();
        // LNB 노출을 위한 목록 (페이지 순서 및 디버그 여부)
        const menuList = ref(initMenu());
        // 열려있는 그룹 목록 (그룹: 관제, 상점, 정책관리 등)
        const openedGroupList = ref([]);
        // 선택된 페이지 (페이지: 운행설정, 라이더 관리 등), vuetify 배열 타입이지만 멀티셀렉이 아니므로 실제론 하나만 들어감.
        const selectedItem = ref([]);
        const setOpenedGroupList = (list) => {
            openedGroupList.value = list;
        };
        const setSelectedItem = (item) => {
            selectedItem.value = [
                item,
            ];
        };
        const isPopupPage = (linkOptions) => linkOptions?.popup;
        /**
         * vuetify3 - popup 페이지는 value를 가지지 않음. (selected에 의해 색칠되어선 안됨)
         */
        const getLinkItemValue = (item) => (isPopupPage(item.linkOptions) ? null : item.title);
        /**
         * 세부 탭 대응을 위한 진입점 확인 로직
         * 예) 라이더 수정, 등록, 상세 또한 라이더 관리이다.
         */
        const getSelectedItemEntryPointName = (routeLocation) => {
            const entryPoint = routeLocation.matched.at(-1)?.path.split('/')[1];
            if (!entryPoint) {
                return '';
            }
            return entryPoint;
        };
        /**
         * 선택 된 페이지가 속한 그룹 확인
         */
        const getOpenedGroupNameBySelectedPage = (selectedPageName) => {
            let result = false;
            let initialOpenedGroup = '';
            menuList.value.forEach((item) => {
                if (!item.children) {
                    return;
                }
                result = item.children.some((val) => val?.linkOptions?.to.name === selectedPageName);
                if (result) {
                    initialOpenedGroup = item.title;
                }
            });
            return initialOpenedGroup;
        };
        /**
         * 선택 된 페이지를 store에 적용
         */
        const syncSelectedPageWithVuexStore = (pageName) => {
            vuexStore.dispatch('app/setSelectedNavItem', pageName);
            vuexStore.dispatch('app/setPageTitle');
        };
        const getFullTitle = ({ title }) => i18n.t(`${lc + title}`);
        /**
         * 그룹 눌러 토글식 열고닫기
         */
        const handleClickNavigationGroup = ({ title }) => {
            const currentLnb = new Set(openedGroupList.value);
            if (currentLnb.has(title)) {
                currentLnb.delete(title);
            }
            else {
                currentLnb.add(title);
            }
            openedGroupList.value = [
                ...currentLnb,
            ];
        };
        /**
         * 링크 눌러 페이지 열기
         */
        const handleClickNavigationLink = (item) => {
            const popupOption = window.Cypress ? 'width=1024,height=768' : 'popup';
            if (!item.linkOptions) {
                return;
            }
            if (item.linkOptions.to.name === routeName.MAP_CONTROL) {
                window.open('/map-control', 'popup-map-control', popupOption);
                return;
            }
            setSelectedItem(item.title);
            router.push(item.linkOptions.to).catch(() => { });
        };
        onMounted(() => {
            const entryPointName = getSelectedItemEntryPointName(route);
            // route는 kebab 페이지는 snake라 필요.
            const entryPointSnakeName = convertCase(entryPointName, 'kebab', 'snake');
            // route는 kebab 페이지 이넘은 pascal이라 필요.
            const entryPointPascalName = convertCase(entryPointName, 'kebab', 'pascal');
            // 1. 최초 로드시 주소에 따라 이미 선택 된 페이지(진입점) 넣기.
            setSelectedItem(entryPointSnakeName);
            // 2. 선택 된 페이지에 따라 열려있는 그룹 넣기.
            const openedGroupName = getOpenedGroupNameBySelectedPage(entryPointPascalName);
            setOpenedGroupList([
                openedGroupName,
            ]);
            // 3. 선택 된 페이지 store 적용 (헤더 컨트롤러 참고값)
            syncSelectedPageWithVuexStore(entryPointPascalName);
        });
        watch(() => route, (value) => {
            const entryPointName = getSelectedItemEntryPointName(value);
            // route는 kebab 페이지는 snake라 필요.
            const entryPointSnakeName = convertCase(entryPointName, 'kebab', 'snake');
            // route는 kebab 페이지 이넘은 pascal이라 필요.
            const entryPointPascalName = convertCase(entryPointName, 'kebab', 'pascal');
            // 1. 라우트 변경 시 현재 페이지의 진입점 저장
            setSelectedItem(entryPointSnakeName);
            // 2. 선택 된 페이지 vuexStore 적용 (헤더 컨트롤러 참고값)
            syncSelectedPageWithVuexStore(entryPointPascalName);
        }, {
            deep: true,
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_group = _resolveComponent("v-list-group");
            const _component_v_list = _resolveComponent("v-list");
            return (_openBlock(), _createElementBlock("div", null, [
                _createCommentVNode(" opened: 열려있는 그룹 목록"),
                _createCommentVNode(" open-strategy: 기본값은 list [item 선택 시 다른 그룹은 모두 닫힘] "),
                _createVNode(_component_v_list, {
                    density: "compact",
                    "active-class": "active-lnb",
                    nav: "",
                    "open-strategy": "multiple",
                    selected: selectedItem.value,
                    opened: openedGroupList.value
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: item.title
                            }, [
                                _createCommentVNode(" 자식 요소 없는 케이스 "),
                                (!item.children)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: key,
                                        value: getLinkItemValue(item),
                                        onClick: _withModifiers(($event) => (handleClickNavigationLink(item)), ["stop"])
                                    }, {
                                        title: _withCtx(() => [
                                            _createCommentVNode(" 개발환경 디버그 요소 확인용입니다. "),
                                            (item.debug)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                                                    _createVNode(_component_v_icon, { size: "16" }, {
                                                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                            _createTextVNode(" mdi-wrench ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [0]
                                                    })
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(" " + _toDisplayString(getFullTitle(item)), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onClick"]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createCommentVNode(" 자식 요소 있는 케이스 "),
                                        _withDirectives(_createVNode(_component_v_list_group, {
                                            value: item.title
                                        }, {
                                            activator: _withCtx(() => [
                                                _createVNode(_component_v_list_item, {
                                                    class: "group-activator",
                                                    onClick: ($event) => (handleClickNavigationGroup(item))
                                                }, {
                                                    title: _withCtx(() => [
                                                        _createCommentVNode(" 개발환경 디버그 요소 확인용입니다. "),
                                                        (item.debug)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                                                _createVNode(_component_v_icon, { size: "16" }, {
                                                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                                        _createTextVNode(" mdi-wrench ")
                                                                    ])),
                                                                    _: 1 /* STABLE */,
                                                                    __: [1]
                                                                })
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createTextVNode(" " + _toDisplayString(getFullTitle(item)), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                            ]),
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (children, index) => {
                                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: index,
                                                        class: "second-depth-link",
                                                        value: getLinkItemValue(children),
                                                        onClick: _withModifiers(($event) => (handleClickNavigationLink(children)), ["stop"])
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => [
                                                                    (children.debug)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                                                            _createVNode(_component_v_icon, { size: "16" }, {
                                                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                                                    _createTextVNode(" mdi-wrench ")
                                                                                ])),
                                                                                _: 1 /* STABLE */,
                                                                                __: [2]
                                                                            })
                                                                        ]))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _createElementVNode("span", {
                                                                        "data-cy": `lnb-${children.title}`
                                                                    }, _toDisplayString(getFullTitle(children)), 9 /* TEXT, PROPS */, _hoisted_4),
                                                                    (isPopupPage(children.linkOptions))
                                                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                            key: 1,
                                                                            small: ""
                                                                        }, {
                                                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                                                _createTextVNode(" mdi-open-in-new ")
                                                                            ])),
                                                                            _: 1 /* STABLE */,
                                                                            __: [3]
                                                                        }))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _createCommentVNode(" 여기까지 ")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onClick"]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]), [
                                            [_vShow, item.children[0]]
                                        ])
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["selected", "opened"])
            ]));
        };
    }
});
